module.exports = __webpack_public_path__ + "media/images/ui__textArrowDownAccent--dark-f08764c73f16e7755cb43327d93411d1.png";